import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFixedHeight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFixedHeight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.752 3.75a.75.75 0 0 1-.75.75H6A.75.75 0 1 1 6 3h12.002a.75.75 0 0 1 .75.75M12.002 17a.75.75 0 0 1-.75-.75v-8.5a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-.75.75m6 4.003a.75.75 0 1 0 0-1.5H6a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFixedHeight24);
